export default __webpack_public_path__ + "content/media/12.fee713e6.jpg";